import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const AnimatedVerticalLine = ({ delay = 0.5 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });

  return (
    <div ref={ref} className="w-[1px] h-full bg-white/10 overflow-hidden">
      <motion.div
        className="w-full bg-white/30"
        initial={{ height: '0%' }}
        animate={isInView ? { height: '100%' } : { height: '0%' }}
        transition={{ duration: 1.5, delay, ease: 'easeOut' }}
      />
    </div>
  );
};

export default AnimatedVerticalLine;
